export interface BooleanOptionControlProps {
  value: boolean
  onToggle: () => void
  buttonClassName: string
  registerButton?: (el: HTMLButtonElement | null) => void
}

export function BooleanOptionControl({ value, onToggle, buttonClassName, registerButton }: BooleanOptionControlProps) {
  return (
    <button ref={registerButton} tabIndex={-1} className={buttonClassName} onClick={onToggle}>
      {value ? 'On' : 'Off'}
    </button>
  )
}

